import React from "react";
//#region types
import { TansactionListTable, TransactionListProps } from "models/propTypes/voucherPropsTypes";
import { TranslationKeys } from "translations";
import { Amount } from "models/utilTypes/currencyType";
import { CurrencyEnums } from "models/enums";
//#endregion
//#region components
import { Tags, TableAsync } from "components/common";
//#endregion

const TransactionsList: React.FC<TransactionListProps> = (props) => {
  const getRows = () => {
    return (
      props.transactions?.map(
        (transaction): TansactionListTable => ({
          postedAs: `${props.series} ${transaction.account} ${transaction.accountName}`,
          transactionText: transaction.transactionText,
          debit:
            transaction.amount >= 0
              ? new Amount(CurrencyEnums.CurrencyCode.SEK, Math.abs(transaction.amount))
              : undefined,
          credit:
            transaction.amount < 0
              ? new Amount(CurrencyEnums.CurrencyCode.SEK, Math.abs(transaction.amount))
              : undefined,
          tags: <Tags tags={transaction.dimensions ?? []} maxDisplayCount={1} />,
        })
      ) ?? []
    );
  };

  return (
    <TableAsync<TansactionListTable>
      properties={{
        postedAs: {
          description: TranslationKeys.Common.PostedAs,
          isTextSmall: true,
          width: "25%",
        },
        transactionText: {
          description: TranslationKeys.Common.TransactionText,
          width: "25%",
        },
        debit: { description: TranslationKeys.Common.Debit, alignment: "right", classification: "amount" },
        credit: { description: TranslationKeys.Common.Credit, alignment: "right", classification: "amount" },
        tags: { description: TranslationKeys.Common.Tags },
      }}
      filter={getRows()}
      pagination={false}
    />
  );
};

export default TransactionsList;
